import * as React from 'react';
import './ServiceCard.css';

export default function ServiceCard({title, icon}) {
const [cardClass]= React.useState("miclase");
const [overlayClass]= React.useState("");

  return (
    <>
      <div className={overlayClass}></div>
      <div className="card-container">
        <div id={`card-${title}`} className={cardClass} >
          {icon}
          <h3>{title}</h3>
        </div>
      </div>
    </>
  );
}